import { postTrackViewData, putTrackViewDataUpdate } from '@/api/track'

export default {
  20(context, data) {
    const { companyUnicode } = context
    const param = {
      moduleId: 20,
      browseDuration: 3,
      bizUnicode: data.id,
      targetMemberCode: companyUnicode,
    }
    postTrackViewData(param)
  },
  /**
   * @name UVPV 固定名称不支持修改
   * @desc UV、PV埋点
   * @param {Object} context 当前上下文
   */
  async UVPV(context) {
    console.log('UVPV', context)
    // window.test1 = context
    const { $route, memberunicode } = context
    // console.log('route', $route, $route.name)
    const trackParam = {}
    // 1.当前用户【游客|会员】,由于现在使用get请求告诉后端,后端判断token。
    // 2.当前路由name 获取对应模块id,并且判断需不需要记录
    try {
      for (const item of lookModule) {
        if (item.routeName && item.routeName.includes($route.name)) {
          trackParam.moduleId = item.moduleId
          break
        }
      }
      // console.log('trackParamtrackParam', trackParam, $route, memberunicode)
      if (!trackPageConfig.includes(trackParam.moduleId)) {
        // console.log('UVPV-不记录')
        return
      }
      // 4.模块Code 有则传 $route.params|query
      trackParam.bizUnicode = $route.params.id || $route.params.unicode || $route.params.cloud || $route.query.unicode
      // 5.被查看、转发的用户Code,需要在页面的$data中设置
      trackParam.targetMemberCode = memberunicode
      // 6. shareId 分享Id
      if ($route.query.shareId) {
        trackParam.shareId = $route.query.shareId
      }
      // 7. 异步请求接口,不要导致阻塞
      const res = await postTrackViewData(trackParam)
      if (res.code === 0) {
        // console.log('postTrackViewData', res)
        trackPageViewSaveId[trackParam.moduleId] = res.data.viewSaveId
      }
      // console.log('UVPV-trackParam', trackParam)
    } catch (error) {
      // console.log('UVPV-ERROR', error)
    }
    // 浏览器页签激活状态判断
    // document.addEventListener('visibilitychange', function() {
    //   console.log('标签激活状态：', trackParam.moduleId, document.hidden)
    //   if(document.hidden){
    //     const viewSaveId = trackPageViewSaveId[trackParam.moduleId]
    //     if (viewSaveId) {
    //       putTrackViewDataUpdate({
    //         browseDuration: trackParam.browseDuration,
    //         viewSaveId
    //       })
    //     } else {
    //       postTrackViewData(trackParam)
    //     }
    //   }else{

    //   }
    //   // Modify behavior...
    // })
    // 页签关闭事件
    // window.addEventListener('beforeunload', (event) => {
    //   // Cancel the event as stated by the standard.
    //   // event.preventDefault()
    //   const beforeUnloadTime = new Date().getTime()
    //   console.log('beforeunload', beforeUnloadTime)

    //   // Chrome requires returnValue to be set.
    //   // event.returnValue = ''
    // })
    // window.addEventListener('unload', async (event) => {
    //   // Cancel the event as stated by the standard.
    //   // event.preventDefault()
    //   const beforeUnloadTime = new Date().getTime()

    //   const viewSaveId = trackPageViewSaveId[trackParam.moduleId]
    //   console.log('unload', beforeUnloadTime, viewSaveId)
    //   if (viewSaveId) {
    //     await putTrackViewDataUpdate({
    //       browseDuration: 60,
    //       viewSaveId
    //     })
    //   }
    //   // 加一段同步代码阻塞一下,不然刷新会发不出去异步请求
    //   const now = new Date()
    //   while (new Date() - now < 100) {}
    // })
  },
  /**
   * @name TONP 固定名称不支持修改
   * @desc 页面停留时间埋点（Time on Page）页面离开时触发
   * @param {Object} context 当前上下文
   * @param {Timestamp} et 进入页面时间
   * @param {Timestamp} dt 离开页面时间
   */
  TONP(context, { et, dt }) {
    // console.log('TONP-context', context)
    // console.log('TONP-Timestamp', et, dt)
    const { $route, $moment, memberunicode } = context
    // console.log('route', $route)
    const trackParam = {}
    // 1.当前用户【游客|会员】,由于现在使用get请求告诉后端,后端判断token。
    // 2.当前路由name 获取对应模块id,并且判断需不需要记录
    try {
      for (const item of lookModule) {
        if (item.routeName && $route && $route.name && item.routeName.includes($route.name)) {
          trackParam.moduleId = item.moduleId
          break
        }
      }
      if (!trackPageConfig.includes(trackParam.moduleId)) {
        // console.log('TONP-不记录')
        return
      }
      // 3.浏览时长
      trackParam.browseDuration = $moment(dt).diff($moment(et), 'seconds')
      // 4.模块Code 有则传 $route.params|query
      trackParam.bizUnicode = $route.params.id || $route.params.unicode || $route.query.unicode
      // 5.被查看、转发的用户Code,需要在页面的$data中设置
      trackParam.targetMemberCode = memberunicode
      // 6. shareId 分享Id
      if ($route.query.shareId) {
        trackParam.shareId = $route.query.shareId
      }
      // 7. 浏览时长少于（包括）三秒则不记录
      if (trackParam.browseDuration > 3 && trackParam.targetMemberCode) {
        const viewSaveId = trackPageViewSaveId[trackParam.moduleId]
        if (viewSaveId) {
          putTrackViewDataUpdate({
            browseDuration: trackParam.browseDuration,
            viewSaveId,
          })
        } else {
          postTrackViewData(trackParam)
        }
      }
    } catch (error) {
      // console.log('TONP-ERROR', error)
    }
  },
  // /**
  //  * @name forwardCompanyInfo 转发行为企业主页埋点方法,用于复制链接的行为记录【废弃,使用主动分享的接口】
  //  * @param {Object} context 当前上下文
  //  * @param {Object} args 剩余参数
  //  */
  // forwardCompanyInfo(context, args) {
  //   // console.log('forwardCompanyInfo-context', context)
  //   // console.log('forwardCompanyInfo-args', args)
  //   // forwardModule
  //   const { shareTrackId, shareTargetMemberCode } = context
  //   const trackParam = {}
  //   // 转发的模块Id
  //   console.log('shareTrackId', shareTrackId)
  //   for (const item of forwardModule) {
  //     if (item.moduleId && item.moduleId === shareTrackId) {
  //       trackParam.moduleId = shareTrackId
  //       break
  //     }
  //   }
  //   if (!trackParam.moduleId) {
  //     console.log('不记录')
  //     return
  //   }
  //   // shareType 分享渠道
  //   const shareTypeMap = {
  //     1: 'homePageShare',
  //     2: 'companyPanoramaShare',
  //     3: 'companyVideoShare',
  //     4: 'companyPartnerShare',
  //     5: 'companyPhotoAlbumShare',
  //     6: 'companyEmployeeShare',
  //     7: 'companyHonorShare'
  //   }
  //   trackParam.shareType = ''
  //   // 转发的内容参数（链接）
  //   // const shareParam = link
  //   // trackParam.shareParam = shareParam
  //   // 被查看、转发的用户Code,需要在页面的$data中设置
  //   trackParam.targetMemberCode = shareTargetMemberCode
  //   // 异步请求接口,不要导致阻塞
  //   getTrackForwardCompanyData(trackParam)
  //   console.log(trackParam)
  // }
}

// 查看
const lookModule = [
  {
    moduleName: '企业首页',
    moduleId: 1,
    routeName: ['id'],
  },
  {
    moduleName: '名片',
    moduleId: 27,
    routeName: ['memberHome-id'],
  },
  {
    moduleName: '云上企业',
    moduleId: 2,
  },
  {
    moduleName: '企业视频',
    moduleId: 3,
  },
  {
    moduleName: '合作伙伴',
    moduleId: 4,
  },
  {
    moduleName: '企业相册',
    moduleId: 5,
  },
  {
    moduleName: '企业员工',
    moduleId: 6,
  },
  {
    moduleName: '企业荣誉',
    moduleId: 7,
  },
  {
    moduleName: '投资机构',
    moduleId: 8,
  },
  {
    moduleName: '对外投资',
    moduleId: 9,
  },
  {
    moduleName: '3D企业',
    moduleId: 10,
  },
  {
    moduleName: '展品',
    moduleId: 12,
    routeName: ['product-unicode'],
  },
  {
    moduleName: '直播',
    moduleId: 13,
    routeName: ['live-liveDetail'],
  },
  {
    moduleName: '参展的展览',
    moduleId: 14,
  },
  {
    moduleName: '发布的展览',
    moduleId: 15,
    routeName: ['cloudexhibition-cloud', 'exhibition-unicode'],
  },
  {
    moduleName: '发布的会议',
    moduleId: 16,
    routeName: ['meeting-id'],
  },
  {
    moduleName: '展厅模型',
    moduleId: 17,
    routeName: ['showroom-model-unicode'],
  },
  {
    moduleName: '招标',
    moduleId: 18,
    routeName: ['bidding-id'],
  },
  {
    moduleName: '海报制作',
    moduleId: 19,
  },
  {
    moduleName: '企业动态',
    moduleId: 20,
  },
  {
    moduleName: '联系我们',
    moduleId: 21,
  },
  {
    moduleName: '资讯',
    moduleId: 22,
    routeName: ['news-id'],
  },
  {
    moduleName: '云招聘',
    moduleId: 23,
    routeName: ['recruit-unicode'],
  },
]
// 0.trackPageConfig 跟踪页面的配置,在配置内的才记录
const trackPageConfig = [1, 12, 13, 15, 16, 17, 18, 22, 23, 27]
const trackPageViewSaveId = {
  1: 0,
  12: 0,
  13: 0,
  15: 0,
  16: 0,
  17: 0,
  18: 0,
  22: 0,
  23: 0,
  27: 0,
}
